// extracted by css-extract-rspack-plugin
export default {"cls1":"Instructor-cls1_sTf","cls2":"Instructor-cls2_eb5 Instructor-cls1_sTf"};